var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g({class:['p-inputtext p-component', {'p-filled': _vm.filled}],domProps:{"value":_vm.value}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }